import { render, staticRenderFns } from "./EditConfig.vue?vue&type=template&id=7efbab75&"
import script from "./EditConfig.vue?vue&type=script&lang=js&"
export * from "./EditConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports